var map = {
	"./GameBoardLayout": 74,
	"./GameBoardLayout.ts": 74,
	"./GameEndPopup": 75,
	"./GameEndPopup.ts": 75,
	"./LeaderboardPopup": 198,
	"./LeaderboardPopup.ts": 198,
	"./ShooterLayout": 73,
	"./ShooterLayout.ts": 73,
	"./TestLayout": 199,
	"./TestLayout.ts": 199,
	"./WaitingScreen": 76,
	"./WaitingScreen.ts": 76
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 398;